import { grey3, mainTextColor, white } from 'constants/variables';

export const colorMap = {
  white,
  grey: grey3,
  black: mainTextColor,
};

export const accessibleTextColorMap = {
  white: 'tc-black',
  grey: 'tc-black',
  black: 'tc-white',
};

// Accepts a string from the CMS and maps it to a colour from our variables file, defaults to white
const getColor = string => colorMap[string] || colorMap.white;

// Accepts a string from a component and maps it to an accessible text colour class, defaults to main text colour
export const getAccessibleTextColorClass = string =>
  accessibleTextColorMap[string] || accessibleTextColorMap.white;

export default getColor;
